import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { observer } from 'mobx-react-lite'
import type ConsultationSchedulerViewModel from '../../ConsultationSchedulerViewModel'
import { Button } from '@/components/Button'

interface AvailabilitySubmittedDialogContainerProps {
  vm: ConsultationSchedulerViewModel
}

export const AvailabilitySubmittedDialogContainer = observer(
  function AvailabilitySubmittedDialogContainer({
    vm,
  }: AvailabilitySubmittedDialogContainerProps) {
    const testId = 'availability-submitted-dialog'
    return (
      <ModalDialog
        size="lg"
        isOpen={vm.availabilitySubmittedDialog.showing}
        onClose={vm.close}
        testId={testId}
      >
        <ModalDialogHeader>
          <ModalDialogTitle>
            Great news, we've received your availability schedule!
          </ModalDialogTitle>
          <ModalDialogDescription>
            {vm.job.championPro ? (
              <>
                We'll notify you once your Pro books a date and time based on
                your availability.
              </>
            ) : (
              <>
                We'll now find your perfect Pro and notify you of the booked
                date and time.
              </>
            )}
          </ModalDialogDescription>
        </ModalDialogHeader>
        <ModalDialogFooter>
          <ModalDialogActions>
            <Button
              label="Done"
              onPress={() => vm.availabilitySubmittedDialog.close()}
              testId={`${testId}-done-button`}
            />
          </ModalDialogActions>
        </ModalDialogFooter>
      </ModalDialog>
    )
  },
)
